import store from '../store'

export default {
	data() {
		return {
			screenSize: null
		}
	},
	computed: {
		baseUrl() {
			return store.getters.baseUrl
		},
		isAuth() {
			return store.getters.isAuth
		},
		userToken() {
			return store.getters.userToken
		},
		loginUrl() {
			return store.getters.loginUrl
		},
		claimCreditUrl() {
			return store.getters.claimCreditUrl
		},
		categories() {
			return store.getters.categories
		},
		isNavMenuVisible() {
			return store.getters.isNavMenuVisible
		},
		isCmeInfoModalVisible() {
			return store.getters.isCmeInfoModalVisible
		},
		isCmeRegModalVisible() {
			return store.getters.isCmeRegModalVisible
		},
		urlParams({ $route }) {
			const { query } = $route
			const output = query && Object.keys(query).length > 0 
				? '?' + Object.keys(query).map((key) => {
						return key + '=' + query[key]
					}).join('&')
				: ''

			return output
		},
	},
	methods: {
		async analytics(data) {
			await store.dispatch('submitAnalytics', data)
		}, 
		setScreenSize() {
			this.screenSize = window.innerWidth > 769 && window.innerWidth <= 1024
				? 'tablet'
				: window.innerWidth > 1024 && window.innerWidth <= 1280
				? 'laptop'
				: window.innerWidth > 1280 && window.innerWidth <= 1920
				? 'desktop'
				: window.innerWidth > 1920
				? 'tv'
				: 'mobile'
		},
		userLogin() {
			const url = this.loginUrl

			this.analytics({
				event: 'Click',
				label: 'Log In'
			})

			this.redirect(url, {
				redirect_url: window.location.href
			})
		},
		userLogout() {
			this.analytics({
				event: 'Click',
				label: 'Log Out'
			})

			store.dispatch('userLogout')
		},
		redirect(url, params) {
			if (params && Object.keys(params).length > 0) {
				Object.keys(params).forEach((key) => {
					url = url.replace(new RegExp(`##${ key }##`, 'gi'), params[key])
				})
			}
				
			window.location = url
		},
		openNewTab(url, params) {
			if (Object.keys(params).length > 0) {
				Object.keys(params).forEach((key) => {
					url = url.replace(new RegExp(`##${ key }##`, 'gi'), params[key])
				})
			}

			window.open(url, '_blank')
		},
		async showNavMenu() {
			await store.dispatch('showNavMenu')
			this.checkNavMenuVisibility()
			this.analytics({
				event: 'Click',
				label: 'Show Nav Menu'
			})
		},
		formatTimestamp(timestamp) {
			const split = timestamp.split(' ')
			const dt = split[0].split('-')

			return dt[1] + '/' + dt[2] + '/' + dt[0]
		},
		truncateString(string, max = 50) {
			const split = string.split(' ')
			const newString = split.slice(0, max).join(' ')

			return newString + '...'
		},
		async hideNavMenu() {
			await store.dispatch('hideNavMenu')
			this.checkNavMenuVisibility()
			this.analytics({
				event: 'Click',
				label: 'Hide Nav Menu'
			})
		},
		async showCmeInfoModal() {
			await store.dispatch('showCmeInfoModal')
			this.checkCmeInfoModalVisibility()
			this.analytics({
				event: 'Click',
				label: 'Show Modal | CME Info Modal'
			})
		},
		async hideCmeInfoModal() {
			await store.dispatch('hideCmeInfoModal')
			this.checkCmeInfoModalVisibility()
			this.analytics({
				event: 'Click',
				label: 'Hide Modal | CME Info Modal'
			})
		},
		async showCmeRegModal() {
			await store.dispatch('showCmeRegModal')
			this.checkCmeRegModalVisibility()
			this.analytics({
				event: 'Click',
				label: 'Show Modal | Login Instruction Modal'
			})
		},
		async hideCmeRegModal() {
			await store.dispatch('hideCmeRegModal')
			this.checkCmeRegModalVisibility()
			this.analytics({
				event: 'Click',
				label: 'Hide Modal | Login Instruction Modal'
			})
		},
		showNavMenuSearch() {
			this.showNavMenu()
			setTimeout(function() {
				document.querySelector('#pageNavMenu')
					?.shadowRoot
					.querySelector('#navMenuSearch')
					.querySelector('input')
					.focus()
			}, 200)
		},
		getOffsetTop(arr) {
			let output = 0

			for (let i = 0; i < arr.length; i++) {
				const el = document
					.querySelector(arr[i])
					.shadowRoot
					.querySelector(arr[i])

				output += el.offsetHeight
			}

			return output
		},
		getInnerHeight(el) {
			const computedStyle = window.getComputedStyle(el)
			const padding = Math.floor(computedStyle.paddingTop.replace(/px/gi, '')) + Math.floor(computedStyle.paddingBottom.replace(/px/gi, ''))
			return el.clientHeight - padding
		},
		getOuterHeight(el) {
			const computedStyle = window.getComputedStyle(el)
			const margin = Math.floor(computedStyle.marginTop.replace(/px/gi, '')) + Math.floor(computedStyle.marginBottom.replace(/px/gi, ''))
			return el.clientHeight + margin
		},
		getInnerWidth(el) {
			const computedStyle = window.getComputedStyle(el)
			const padding = Math.floor(computedStyle.paddingLeft.replace(/px/gi, '')) + Math.floor(computedStyle.paddingRight.replace(/px/gi, ''))
			return el.clientWidth - padding
		},
		getOuterWidth(el) {
			const computedStyle = window.getComputedStyle(el)
			const margin = Math.floor(computedStyle.marginLeft.replace(/px/gi, '')) + Math.floor(computedStyle.marginRight.replace(/px/gi, ''))
			return el.clientWidth + margin
		},
		checkNavMenuVisibility() {
			if (this.isNavMenuVisible) document.body.classList.add('disable-scroll')
			else document.body.classList.remove('disable-scroll')
		},
		checkCmeInfoModalVisibility() {
			if (this.isCmeInfoModalVisible) document.body.classList.add('disable-scroll')
			else document.body.classList.remove('disable-scroll')
		},
		checkCmeRegModalVisibility() {
			if (this.isCmeRegModalVisible) document.body.classList.add('disable-scroll')
			else document.body.classList.remove('disable-scroll')
		},
		setContentMargin() {
			const target = document.querySelector('main')
			const stickyNavs = document.querySelectorAll('.sticky-navbar')
			let stickyHeight = 0;

			for (let i = 0; i < stickyNavs.length; i++) {
				const nav = stickyNavs[i]
				stickyHeight += nav.offsetHeight
			}

			target.style.marginTop = stickyHeight + 'px'
		},
		// Transitions
    beforeExpand(el) {
      el.style.height = '0';
    },
    expanded(el) {
			const hasMaxHeight = !!el.style.maxHeight

      el.style.height = hasMaxHeight && el.scrollHeight > Math.floor(el.style.maxHeight.replace(/px/gi, ''))
				? el.style.maxHeight
				: el.scrollHeight + 'px';
    },
    beforeCollapse(el) {
			const hasMaxHeight = !!el.style.maxHeight

      el.style.height = hasMaxHeight && el.scrollHeight > Math.floor(el.style.maxHeight.replace(/px/gi, ''))
				? el.style.maxHeight
				: el.scrollHeight + 'px';
    },
    collapsed(el) {
      el.style.height = '0';
    }
	}
}